(() => {
  const currencyPrefix = /((?:PKR|Rs\.?|₨)\s*[0-9][0-9,]*)\.\d{1,2}\b/g;
  const currencySuffix = /\b([0-9][0-9,]*)\.\d{1,2}(\s*(?:PKR|Rs\.?|₨))/g;
  const ignoredParents = 'script, style, noscript, template, textarea';
  const pendingRoots = new Set();
  let frameId = 0;

  const cleanText = (node) => {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;
    const parent = node.parentElement;
    if (parent && parent.closest(ignoredParents)) return;

    const value = node.nodeValue;
    if (!value || !value.includes('.')) return;
    if (!value.includes('PKR') && !value.includes('Rs') && !value.includes('₨')) return;

    const next = value.replace(currencyPrefix, '$1').replace(currencySuffix, '$1$2');
    if (next !== value) node.nodeValue = next;
  };

  const cleanRoot = (root) => {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      cleanText(root);
      return;
    }
    if (
      root.nodeType !== Node.ELEMENT_NODE &&
      root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE &&
      root.nodeType !== Node.DOCUMENT_NODE
    ) return;
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(ignoredParents)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const value = node.nodeValue;
        if (!value || !value.includes('.')) return NodeFilter.FILTER_REJECT;
        if (!value.includes('PKR') && !value.includes('Rs') && !value.includes('₨')) {
          return NodeFilter.FILTER_REJECT;
        }
        const parent = node.parentElement;
        if (parent && parent.closest(ignoredParents)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    let node;
    while ((node = walker.nextNode())) cleanText(node);
  };

  const flush = () => {
    frameId = 0;
    pendingRoots.forEach(cleanRoot);
    pendingRoots.clear();
  };

  const queueRoot = (root) => {
    if (!root) return;
    pendingRoots.add(root);
    if (!frameId) frameId = window.requestAnimationFrame(flush);
  };

  const start = () => {
    cleanRoot(document.body);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') {
          cleanText(mutation.target);
          continue;
        }
        mutation.addedNodes.forEach(queueRoot);
      }
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();